module.exports = __webpack_public_path__ + "img/1448278419.45b8b122.jpg";